module.exports = __webpack_public_path__ + "MyriadPro-Regular.1698a9b3d7d76c7959a6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MyriadPro-Regular.otf
// module id = 839
// module chunks = 2